/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Flickity from "flickity";

 
class CarouselTestimonial {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carouselElemTestimonial = self.elem.querySelector('[data-carousel-testimonial]');


    }

    init() {
        let self = this;

        self.initCarousels();
    }

    initCarousels() {
        let self = this;
        
        self.flktyTestimonial = new Flickity(self.carouselElemTestimonial, {

            pageDots: false,
            prevNextButtons: false,
            draggable:true,

            autoPlay: 4000,

              
            });



              
        



        self.createListeners(self);
    }
    createListeners(self){
        document.addEventListener('DOMContentLoaded', function () {


        });


    }
    
}

export default CarouselTestimonial;